<div class="table-container" >
  @if (isSearchRequired) {
    <div class="search-controls">
      <div class="search-group">
        @if (!hideFilterAndRefresh) {
          <button  class="btn btn-yellow-filled-small refresh-near" [matTooltip]="'Refresh/ Clear filters..'" (click)="onRefresh()">
            Refresh... <mat-icon>refresh</mat-icon>
          </button>
        }
        <mat-form-field
          class="small"
          appearance="outline"
          [matTooltip]="'The search will apply only for the current page. For remaining pages, add a filter.'"
          matTooltipPosition="above">
          <mat-label>Search</mat-label>
          <input matInput type="text" (keyup)="applyFilter($event)">
          @if (!hideFilterAndRefresh) {
            <button  mat-icon-button matSuffix [matTooltip]="'Apply Filters'" [matMenuTriggerFor]="filterMenu" #menuTrigger="matMenuTrigger">
              <mat-icon>filter_alt</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </div>
  }
</div>

<div #bottomScroll class="bottom-scroll-wrapper">
<!-- Skeleton Loader (display when loading) -->
@if (isLoading) {
  <div class="skeleton-table">
    <div class="skeleton-header">
      @for (column of displayedColumns; track column) {
        <div class="skeleton-cell"></div>
      }
    </div>
    @for (row of skeletonRows; track row) {
      <div>
        <div class="skeleton-row">
          @for (column of displayedColumns; track column) {
            <div class="skeleton-cell"></div>
          }
        </div>
      </div>
    }
  </div>
}
<!-- Actual Table -->
<mat-table [hidden]="isLoading" [dataSource]="dataSource" matSort class="table">

  <!-- Dynamic Column Definitions -->
  @for (column of displayedColumns; track column; let i = $index) {
    <ng-container [matColumnDef]="column.propertyName">
      <!-- Header Cell -->
      <mat-header-cell *matHeaderCellDef mat-sort-header class="t-header-cell"  [ngClass]="i === 0 ? 'sticky-column' : '' ">
        <div class="header-content">
          <span class="column-label">{{ column.label }}</span>
          @if (inlineSearch && isSearchableColumn(column.label)) {
            <input
              matInput
              type="text"
              (keyup)="applyColumnFilter($event, column.propertyName)"
              class="column-filter"
              placeholder="Search"
              />
          }
        </div>
      </mat-header-cell>
      <!-- Data Cell -->
      <mat-cell *matCellDef="let element" class="t-cell"
        [matTooltip]="isOverflowing(column.propertyName, element[column.propertyName]) ? getDisplayValue(column.propertyName, element) : null"
        matTooltipPosition="below"
        [ngClass]="[
        i === 0 ? 'sticky-column' : '',
        column.propertyName === displayedColumns[0].propertyName && isFromGBS ? getcolorClass(element) : ''
      ]">
        <!-- Display Value Cell -->
        @if (column.propertyName !== 'icon') {
          <span [ngStyle]="isNegative(column.propertyName, element)">
            {{ getDisplayValue(column.propertyName, element) }}
          </span>
          @if ((column.propertyName === 'adjReqId' || column.propertyName === 'detailedAdjSubId') && column.showLockIcon && column.showLockIcon(element)) {
            <mat-icon
              class="lock-icon"
              matTooltip="PRS/Consolidated Request"
              >
              inventory_2
            </mat-icon>
          }
        } @else {
          <div class="action-cell">
            @for (icon of column.icons; track icon) {
              <mat-icon
                [matTooltip]="!(icon.isDisabled && icon.isDisabled(element)) ? getDynamicTooltip(icon, element) : ''"
                [class.disabled-icon]="icon.isDisabled && icon.isDisabled(element)"
                [ngClass]="icon.customClass"
                role="button"
                tabindex="0"
                (click)="
                  !(icon.isDisabled && icon.isDisabled(element)) &&
                  (icon.onClick ? icon.onClick(element, comp) : isOpenDialog(element, icon.callFrom))
                "
                (keydown.enter)="
                  !(icon.isDisabled && icon.isDisabled(element)) &&
                  (icon.onClick ? icon.onClick(element, comp) : isOpenDialog(element, icon.callFrom))
                "
                (keydown.space)="
                  $event.preventDefault();
                  !(icon.isDisabled && icon.isDisabled(element)) &&
                  (icon.onClick ? icon.onClick(element, comp) : isOpenDialog(element, icon.callFrom))
                "
                >
                {{icon.icon}}
              </mat-icon>
            }
          </div>
        }
      </mat-cell>
    </ng-container>
  }

  <!-- Header & Data Rows -->
  <mat-header-row *matHeaderRowDef="getColumnPropertyNames(); sticky: true" class="t-header-row"></mat-header-row>
<mat-row *matRowDef="let row; columns: getColumnPropertyNames()"  [ngClass]="(isFromReports && ( row.hasOwnProperty('miApproval') && row.miApproval.flag)) ? 'miFlag' : (isFromReports && (row.hasOwnProperty('gbsApproval') && row.gbsApproval.flag)) ? 'gbsFlag': ''" class="t-row"></mat-row>

  <!-- No Data Message -->
  <div *matNoDataRow>
    <div class="nodata">No Data Available</div>
  </div>

</mat-table>
</div><!-- end bottom-scroll-wrapper -->

@if (isSearchRequired) {
  <div>
    <!-- Manual Pagination -->
    @if (useManualPaging) {
      <mat-paginator
        class="t-pagination"
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20, 50]"
        (page)="onPaginateChange($event)"
        [showFirstLastButtons]="true">
      </mat-paginator>
    }
    <!-- Default Pagination -->
    @if (!useManualPaging) {
      <mat-paginator
        class="t-pagination"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        [showFirstLastButtons]="true">
      </mat-paginator>
    }
  </div>
}


<mat-menu #filterMenu="matMenu" xPosition="before" yPosition="below">
  <div class="filter-menu-content" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
    <h4>Add Filters</h4>
    @for (f of filters; track f; let i = $index) {
      <div class="filter-row">
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="f.column">
            @for (col of FilteredColumns; track col) {
              <mat-option
                [value]="col.propertyName"
                [disabled]="isColumnAlreadySelected(col.propertyName, f)">
                {{ col.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="f.operator">
            <mat-option value="contains">Contains</mat-option>
            <mat-option value="equals">Equals</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Value</mat-label>
          @if (f.column === 'adjReq') {
            <mat-select [(ngModel)]="f.value">
              <mat-option value="1">CREDIT ONLY</mat-option>
              @if (!isLabelHidden) {
                <mat-option value="2">CREDIT/REBILL</mat-option>
              }
              @if (!isLabelHidden) {
                <mat-option value="3">SATURDAY INVOICE</mat-option>
              }
            </mat-select>
          } @else {
            @if (f.column === 'statusName' || f.column === 'statusDesc') {
              <mat-select [(ngModel)]="f.value">
                <!-- <mat-option [value]="0">All</mat-option> -->
                <mat-option [value]="1">Submitted</mat-option>
                <mat-option [value]="16">PRS Submitted</mat-option>
                <mat-option [value]="5">MI Approved</mat-option>
                <mat-option [value]="3">First Level Need More Information</mat-option>
                <mat-option [value]="4">First Level Rejected</mat-option>
                <mat-option [value]="6">Completed</mat-option>
                <mat-option [value]="7">Received</mat-option>
                <mat-option [value]="8">Waiting for Approval</mat-option>
                <mat-option [value]="9">Sent to Corrections</mat-option>
                <mat-option [value]="10">Pending Rebill</mat-option>
                <mat-option [value]="11">GBS Rejected</mat-option>
                <mat-option [value]="13">GBS Need More Info</mat-option>
                <mat-option [value]="14">Cancelled</mat-option>
                <mat-option [value]="15">Saved</mat-option>
                <mat-option [value]="17">Completed - Refund info is needed</mat-option>
                <mat-option [value]="18">Second Level Rejected</mat-option>
                <mat-option [value]="19">Second Level Need More Information</mat-option>
                <mat-option [value]="20">First Level Approved</mat-option>
              </mat-select>
            }
            @if (f.column !== 'statusName' && f.column !== 'statusDesc') {
              <input matInput [(ngModel)]="f.value">
            }
          }
        </mat-form-field>
        <button mat-icon-button (click)="removeFilter(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    <button mat-stroked-button (click)="addFilter()" class="add-filter-btn">
      <mat-icon>add</mat-icon> Add Filter
    </button>

    <div class="filter-actions">
      <button mat-button (click)="closeMenu()">Cancel</button>
      <button mat-raised-button color="primary" (click)="applyFilters(); closeMenu()">Apply</button>
    </div>
  </div>
</mat-menu>
